import { render, staticRenderFns } from "./GoGreen.vue?vue&type=template&id=da2b86e6&scoped=true&"
var script = {}
import style0 from "./GoGreen.vue?vue&type=style&index=0&id=da2b86e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2b86e6",
  null
  
)

export default component.exports